import CHILE_OFFER_FLOW_STEP_IDS from '../../../../../constants/factoring/chile-offer-flow-step-ids';
import UploadCertificateStep from '../../steps/UploadCertificateStep';

const TITLES = {
  hasStoredCertificate: 'Ingrese la clave de tu certificado digital',
  uploadNew: 'Sube tu certificado digital',
};

export default function buildUploadCertificateConfiguration({
  hasDigitalCertificate,
  selectedProvider,
  onCertificateUploaded,
  requireBankAccount,
}) {
  return {
    id: CHILE_OFFER_FLOW_STEP_IDS.UPLOAD_CERTIFICATE,
    title: hasDigitalCertificate ? TITLES.hasStoredCertificate : TITLES.uploadNew,
    tooltipTitle:
      'El certificado digital es una herramienta de seguridad que permite firmar documentos digitales con validez legal. Consulta el centro de ayuda para saber cómo adquirir e instalar el certificado. Para más información, contacta a tu ejecutivo/a',
    component: UploadCertificateStep,
    props: {
      selectedProvider,
      onCertificateUploaded,
      requireBankAccount,
    },
  };
}
